/** 
    getBounds (media, selection) 
    @media {array} array of objects with {id, x, y, width, height}
    @selection {array} of ids

    returns {minX, minY, maxX, maxY}
*/

export const getBounds = function (media, selection){
    let bounds = {
        minX: Number.MAX_SAFE_INTEGER,
        minY: Number.MAX_SAFE_INTEGER,
        maxX: Number.MIN_SAFE_INTEGER,
        maxY: Number.MIN_SAFE_INTEGER
    };

    media.forEach(function(item){
        if (!selection 
            || selection.indexOf(item.id) !== -1) 
        {
            bounds.minX = Math.min(bounds.minX, item.x);
            bounds.minY = Math.min(bounds.minY, item.y);
            bounds.maxX = Math.max(bounds.maxX, item.x + item.width);
            bounds.maxY = Math.max(bounds.maxY, item.y + item.height);
        }
    });

    return bounds;
}

/*
    getIntersects (media, bounds) 
    @media: array of objects with {id, x, y, width, height}
    @bounds: {minX, minY, maxX, maxY}

    returns array of {id}
*/
export const getIntersects = function (media, bounds){
    const intersects = [];

    if (bounds.maxX - bounds.minX == 0 
        && bounds.maxY - bounds.minY == 0) {
        return intersects;
    }

    media.forEach(function(item){
        if ((item.x < bounds.maxX && item.x + item.width > bounds.minX)
            &&
            (item.y < bounds.maxY && item.y + item.height > bounds.minY)) 
        {
            intersects.push(item.id);
        }
    });

    return intersects;
}

export const getMaxRectInBounds = function (contentW, contentH, boundingW, boundingH) {
    const scale = Math.min( boundingW/contentW, boundingH/contentH);

    return {
        scale,
        width: scale * contentW,
        height: scale * contentH
    }
}

export function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n))
}

export default {
    getBounds,
    getIntersects,
    getMaxRectInBounds,
    clamp
}